import React from "react";
import google from "../../assets/img/google.png";
import facebook from "../../assets/img/facebook.png";
import hunt from "../../assets/img/product-hunt-l.png";
export default function ClientSection() {
  return (
    <section className="client-section d-flex align-items-center text-center">
      <div className="container">
        <h5 className="h5 light text-light-grey m-t-25">Recognized By</h5>
        <picture>
          <source
            type="image/webp"
            srcSet={`${require("../../assets/webp/google.webp")}, ${require("../../assets/webp/google@2x.webp")} 2x, ${require("../../assets/webp/google@3x.webp")} 3x`}
          />
          <img
            src={google}
            srcSet={`${require("../../assets/img/google@2x.png")} 2x,
                        ${require("../../assets/img/google@3x.png")} 3x`}
            className="img-fluid"
            width="150px"
            alt="Google-icon"
          />
        </picture>
        <picture>
          <source
            type="image/webp"
            srcSet={`${require("../../assets/webp/facebook.webp")}, ${require("../../assets/webp/facebook@2x.webp")} 2x, ${require("../../assets/webp/facebook@3x.webp")} 3x`}
          />
          <img
            src={facebook}
            srcSet={`${require("../../assets/img/facebook@2x.png")} 2x,
                        ${require("../../assets/img/facebook@3x.png")} 3x`}
            className="img-fluid"
            width="150px"
            alt="Facebook-Icon"
          />
        </picture>
        <picture>
          <source
            type="image/webp"
            srcSet={`${require("../../assets/webp/product-hunt-l.webp")}, ${require("../../assets/webp/product-hunt-l@2x.webp")} 2x, ${require("../../assets/webp/product-hunt-l@3x.webp")} 3x`}
          />

          <img
            src={hunt}
            srcSet={`${require("../../assets/img/product-hunt-l@2x.png")} 2x,
                        ${require("../../assets/img/product-hunt-l@3x.png")} 3x`}
            className="img-fluid"
            width="150px"
            alt="Product-Hunt"
          />
        </picture>
      </div>
    </section>
  );
}
